import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { CREATE_CUSTOMER, VIEW_CUSTOMER, DELETE_CUSTOMER } from "../config/api";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function Users() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Get the authToken from cookies
      const authToken = Cookies.get("authToken");

      // Decode the token to get user ID
      if (authToken) {
        const decodedToken = jwtDecode(authToken);
        const userId = decodedToken.claims.id;

        // Prepare the payload
        const payload = {
          name: formData.name,
          email: formData.email,
          phoneNumber: formData.phoneNumber,
          username: formData.username,
          password: formData.password,
        };

        // Make API request to create customer
        const response = await axios.post(
          `${CREATE_CUSTOMER}${userId}`,
          payload
        );
        console.log(response);
        if(!response.data.error){
          toast.success("Customer created successfully");
          setFormData({
            name: "",
            email: "",
            phoneNumber: "",
            username: "",
            password: "",
          });
        }
        else if(response.data.error) {
          toast.warn(response.data.response);
        }
      }
    } catch (error) {
      console.error("Error creating customer", error);
      toast.warn(error.data.response)
      // Show error toast
      toast.error("Error creating customer");
    }
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        // Get the authToken from cookies
        const authToken = Cookies.get("authToken");

        // Check if the token exists
        if (authToken) {
          const decodedToken = jwtDecode(authToken);
          const userId = decodedToken.claims.id;
          const response = await axios.get(VIEW_CUSTOMER + userId, {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          });

          if (response.status === 200) {
            setCustomers(response.data.meta);
          }
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
        toast.error("Error fetching customers");
      }
    };

    fetchCustomers();
  }, []);

  const deleteEmployee = async () => {
    try {
      const authToken = Cookies.get("authToken");

      if (authToken && selectedCustomerId) {
        await axios.delete(`${DELETE_CUSTOMER}${selectedCustomerId}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        // Update customer list after deletion
        setCustomers((prevCustomers) =>
          prevCustomers.filter((customer) => customer.id !== selectedCustomerId)
        );

        toast.success("Customer deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting customer:", error);
      toast.error("Error deleting customer");
    } finally {
      setSelectedCustomerId(null); // Reset selected customer
    }
  };

  const showUser = (id) => {
    navigate(`/user/${id}`);
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="pill">Customers</h4>
                <button
                  className="nav-link btn btn-success create-new-button"
                  data-toggle="modal"
                  data-target="#createCustomerModal"
                >
                  Create New
                </button>
              </div>
              <div className="table-responsive">
                <table className="table text-center">
                  <thead>
                    <tr>
                      <th>S No.</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Username</th>
                      <th>Mobile</th>
                      {/* <th>Status</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.length > 0
                      ? customers.map((customer, index) => (
                          <tr key={customer.id}>
                            <td>{index + 1}</td>
                            <td
                              className="table-select"
                              onClick={() => showUser(customer.id)}
                            >
                              {customer.name}
                            </td>
                            <td>{customer.email}</td>
                            <td>{customer.username}</td>
                            <td>{customer.phoneNumber}</td>
                            {/* <td>
                          <label className="badge badge-danger">Pending</label>
                        </td> */}
                            <td>
                              <button
                                className="btn btn-secondary btn-rounded btn-icon mx-2"
                                onClick={() => showUser(customer.id)}
                              >
                                <i className="mdi mdi-eye m-0" />
                              </button>
                              <button
                                className="btn btn-danger btn-rounded btn-icon mx-2"
                                data-toggle="modal"
                                data-target="#deleteCustomerModal"
                                onClick={() =>
                                  setSelectedCustomerId(customer.id)
                                }
                              >
                                <i className="mdi mdi-delete m-0" />
                              </button>
                            </td>
                          </tr>
                        ))
                      : "No Users Found"}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Modal */}
      <div
        className="modal fade"
        id="createCustomerModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create New Customer
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <ToastContainer />

              <form className="forms-sample" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="exampleInputUsername1">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputUsername1"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputUsername1">Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputUsername1"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="Mobile"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputEmail1"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    placeholder="Username"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Password"
                  />
                </div>
                <button type="submit" className="btn btn-primary mr-2">
                  Create
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="deleteCustomerModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="deleteCustomerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteCustomerModalLabel">
                Confirm Deletion
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setSelectedCustomerId(null)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete this customer?
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setSelectedCustomerId(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
                onClick={deleteEmployee}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
